
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from '../controlador';
    import { Publicacion } from '@/__env/lib/MercadoLibre/Publicaciones';
    import { Wait, WaitEntre } from '@/__env/ext';
    import { Pregunta } from '@/__env/lib/MercadoLibre/Preguntas';
    import item from './utiles-publicaciones-item.vue';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            item,
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorSeccion;

        mounted()
        {
            this.Controlador.BarraLateralWidth = 440;
        }
        public Publicaciones: Publicacion[] = [];
        public Cargando: boolean = false;

        public Busqueda: string = '';
        @Watch( 'Busqueda' )
        async onBusqueda()
        {
            let bb = this.Busqueda;
            await Wait( 600 );
            if ( bb == this.Busqueda )
            {
                this.Buscar();
            }
        }

        async Buscar()
        {
            this.Publicaciones.clear();
            this.Cargando = true;
            let e = await Publicacion.find( { respetar_filtros: 'S', estado: 'active', cuenta: this.Controlador.Seleccionada.Cuenta, q: this.Busqueda } );
            if ( e.Items.hasRows() )
            {
                this.Publicaciones = e.Items;
            }
            this.Cargando = false;
        }

        Cerrar()
        {
            this.Controlador.Vista.Modo = 'respuestas';
        }
    }
